import axios from 'axios'
// import router from '@/router'
/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
// const toLogin = () => {
//     router.replace({
//         path: '/login',
//         query: {
//             redirect: router.currentRoute.fullPath
//         }
//     });
// };

const errorHandle = (status, other) => {
    // 状态码判断
    switch (status) {
        case 401:
            console.log('未登录');
            break;
        case 403:
            console.log('登录过期，请重新登录');
            break;
        case 404:
            console.log('请求的资源不存在');
            break;
        default:
            console.log(other);
    }
};

var instance = axios.create({
    timeout: 8 * 1000,
    // headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded',
    //     'App-Version': '1.0'
    // }
});
/**
 * 请求拦截
 */
instance.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.error(error);
    }
);
/**
 * 响应拦截
 */
instance.interceptors.response.use(
    res => {
        // console.log('接口返回', res);
        if (res.status === 200) {
            return Promise.resolve(res.data);
        } else {
            return Promise.reject(res);
        }
    },
    error => {
        const { response } = error;
        if (response) {
            switch (response.status) {
                case 401:
                    console.log('未登录');
                    break;
                case 403:
                    console.log('登录过期，请重新登录');
                    break;
                case 404:
                    console.log('请求的资源不存在');
                    break;
                default:
                    console.log(response.data.message);
            }
            return Promise.reject(response);
        } else {
            // 处理断网的情况
            // store.commit('changeNetwork', false);
        }
    }
);

export default instance;